/**
 * Where the widget's own files are served: the experiences' art lives in
 * public/experiences/<key>/ and ships beside widget.js. On woodsidebible.org
 * the base is the script's directory (widgets.woodsidebible.org/event-details/,
 * set at boot from document.currentScript); in the dev app it is the site root.
 */
let base = '/';

export function setAssetBase(url: string) {
  base = url.endsWith('/') ? url : `${url}/`;
}

/** "experiences/what-matters-2026/art/watercolor.png" -> full URL */
export function asset(path: string): string {
  return `${base}${path.replace(/^\//, '')}`;
}
